import React from "react";
import { useField, useFormikContext } from "formik";
import { DatePicker } from "@material-ui/pickers";
import { InputAdornment, Icon } from "@material-ui/core";
import PropTypes from "prop-types";

function FormikDatePicker({
  name,
  label,
  icon = "calendar_today",
  iconPosition = "start",
  variant = "outlined",
  ...props
}) {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();

  return (
    <DatePicker
      label={label || name}
      inputVariant={variant}
      value={field.value || null}
      onChange={(val) => setFieldValue(name, val)}
      InputProps={{
        startAdornment: (
          <InputAdornment position={iconPosition}>
            <Icon>{icon}</Icon>
          </InputAdornment>
        ),
      }}
      error={meta.touched && Boolean(meta.error)}
      helperText={meta.touched && meta.error ? meta.error : ""}
      {...props}
    />
  );
}

FormikDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  icon: PropTypes.string,
  iconPosition: PropTypes.oneOf(["start", "end"]),
  variant: PropTypes.string,
};

export default FormikDatePicker;
